"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const stdout_1 = require("./stdout");
const digraph_1 = require("./digraph");
const dep_graph_1 = require("./dep-graph");
function parse(stdout, includeTestScope = false, verboseEnabled = false) {
    const digraphs = (0, stdout_1.parseStdout)(stdout);
    const mavenGraphs = (0, digraph_1.parseDigraphs)(digraphs);
    const scannedProjects = [];
    for (const mavenGraph of mavenGraphs) {
        const depGraph = (0, dep_graph_1.buildDepGraph)(mavenGraph, includeTestScope, verboseEnabled);
        scannedProjects.push({ depGraph });
    }
    return {
        scannedProjects,
    };
}
exports.parse = parse;
//# sourceMappingURL=index.js.map